import{gql as e}from"@apollo/client";const r=e`
  query searchUserTypes($projectId: String, $skipUserCount: Boolean = true) {
    userType {
      searchUserTypes(projectId: $projectId) {
        id
        name
        permission
        status
        userCount @skip(if: $skipUserCount)
        userTypeCode
      }
    }
  }
`;export{r as SEARCH_USER_TYPES_QUERY};
//# sourceMappingURL=useSearchUserTypes.graphql.js.map
